<div class="row">
  <div class="col-md-12 jobsDesContainer">
    <div class="row">
      <div class="col-lg">
        <h3 class="jobHeading">{{model.title}}</h3>
        <p class="jobCity"><ng-container *ngIf="theme.filterConfiguration.useLocationNameFilter">{{model.locationName}} - </ng-container>{{model.location}}</p>
        <div class="mb-3">
          <div class="shortFeaure">
            <i class="fa fa-clock-o" aria-hidden="true"></i> Posted: {{model.displayPostedDate | date:'MM/dd/yyyy'}}
          </div>
          <div *ngIf="model.displayApplicationDeadline" class="shortFeaure">
            <i class="fa fa-hourglass-o" aria-hidden="true"></i> Deadline: {{ model.applicationDeadline ? (model.applicationDeadline | date:'MM/dd/yyyy') : 'Open until filled'}}
          </div>
          <div class="shortFeaure">
            <i class="fa fa-file-text-o" aria-hidden="true"></i> Employment: {{model.employmentType}}
          </div>
          <div class="shortFeaure">
            <i class="fa fa-usd" aria-hidden="true"></i> Pay: {{model.compensationRange}}
          </div>
          <div class="shortFeaure">
            <i class="fa fa-building-o" aria-hidden="true"></i> Department: {{model.departmentName}}
          </div>
          <div *ngIf="model.experience" class="shortFeaure">
            <i class="fal fa-layer-group" aria-hidden="true"></i> Experience: {{getExperienceDisplayValue(model.experience)}}
          </div>
        </div>
        <button type="button" mdbBtn class="btn btn-apply m-0" (click)="apply()" mdbWavesEffect>Apply</button>
      </div>
      <div class="col-lg" *ngIf="theme.displayMap" style="margin-top:10px">
        <iframe *ngIf="mapSource" id="jobMap" width="100%" height="230" frameborder="0" [src]="mapSource" style="border:0"></iframe>
      </div>
    </div>

    <ng-container *ngFor="let section of sections">
      <ng-container *ngIf="section.items.length">
        <h4 *ngIf="section.heading">{{section.heading}}</h4>
        <ng-container *ngIf="section.type !== 'video'">
          <ng-container *ngFor="let item of section.items">
            <h4 *ngIf="section.getItemHeading">{{section.getItemHeading(item)}}</h4>
            <div [innerHTML]="section.getItemContent(item)"></div>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="section.type === 'video' && model.videos.length">
          <ng-container *ngFor="let element of model.videos">
            <div class="col-md-12 video-container">
              <div [innerHTML]="element.intro"></div>
              <iframe width="560" height="315" [src]="sanitizeVideo(element.embedLink)" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
    </ng-container>
  </div>
  <ngx-json-ld [json]="jsonLD"></ngx-json-ld>

  <div class="col-md-12">
    <p><button type="button" mdbBtn class="btn btn-apply m-0" (click)="apply()" mdbWavesEffect>Apply</button></p>
  </div>
</div>
